function ajaxCallbackTest(response, targetSelector) {
	let targetElement = jQuery(targetSelector);
	console.log(response);
	// Convert the response.debug object to a formatted string and wrap it in a <pre> tag
	let formattedResponse = '<pre>' + JSON.stringify(response.debug, null, 4) + '</pre>';
	targetElement.html(formattedResponse); // Set the formatted string as the HTML of the target element
	targetElement.removeClass("text-bg-danger");
	targetElement.addClass("text-bg-success");
}

window.ajaxCallbackTest = ajaxCallbackTest;

